import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxUiLoaderService } from 'ngx-ui-loader';

import { Globals } from 'app/_models/globals';
import { LocalStorageUtilsBuyer } from 'app/buyer/_utils/localstoragebuyer';

import { NotificationService } from 'app/_services/notification.service';
import { BuyerReviewService } from 'app/buyer/avaliacoes/avaliacoes.service';
import { UserService } from 'app/_services/user.service';

declare const $: any;

@Component({
    selector: 'dashboard-modal-avaliacao-component', templateUrl: './modal-avaliacao.component.html', styleUrls: ['./modal-avaliacao.component.scss'],
    standalone: false
})
export class BuyerDashboardModalAvaliacaoComponent {
    @ViewChild('templateModalAvaliacao') template: TemplateRef<any>;
    @Input() avaliacoes;
    modalRef: BsModalRef;
    selectedOrder;

    private localStorageUtilsBuyer = new LocalStorageUtilsBuyer;

    constructor(
        private userService: UserService,
        private reviewService: BuyerReviewService,
        private modalService: BsModalService,
        private notificationService: NotificationService,
        private globals: Globals,
        private ngxLoader: NgxUiLoaderService) { }

    async close(): Promise<void> {
        if (this.modalRef)
            this.modalRef.hide()
    }

    changeAvaliacao(avaliacao, clickId): void {
        if((clickId == 0 && !avaliacao.foi_bom) || (clickId == 1 && avaliacao.foi_bom)) //0 = ThumbsDown, 1 = ThumbsUp
            return;

        avaliacao.foi_bom = !avaliacao.foi_bom

        $(`#comment-${avaliacao.id}`).val('');
    }

    open(): Promise<boolean> {
        return new Promise<boolean>(resolve => {
            let shouldOpen = this.localStorageUtilsBuyer.getShouldOpenAvaliacoesModal(this.userService.user());

            if(shouldOpen) {
                this.modalRef = this.modalService.show(this.template, { class: 'avaliacao-modal', backdrop: 'static', keyboard: false  });
            }

            resolve(true);
        })
    }

    rateAllOrders(): void {
        let anyInvalid;
        let $firstInvalid = undefined;

        this.avaliacoes = this.avaliacoes.map(avaliacao => {
            avaliacao.isInvalid = !avaliacao.foi_bom && !avaliacao.avaliacao_texto; //Negativo e sem comentário
            anyInvalid = avaliacao.isInvalid || anyInvalid;

            if ($firstInvalid == undefined && avaliacao.isInvalid)
                $firstInvalid = $(`#comment-${avaliacao.id}`);

            return avaliacao;
        })

        if (anyInvalid) {
            this.notificationService.showErrorToastr(this.globals.translate('buyer.visao-geral.avaliacao.mensagens.erro.falta-comentarios.corpo'));
            $firstInvalid.focus();
            return;
        }

        this.ngxLoader.startLoader('loader-avaliacao');

        let avaliacoes = this.avaliacoes.map((avaliacao: { entregou_no_prazo: any; pecas: any[]; id: any; seller_company_id: any; foi_bom: any; avaliacao_texto: any; }) => {
            avaliacao.entregou_no_prazo = avaliacao.pecas.every(p => p.entrega_no_prazo)
            return {
                id: avaliacao.id,
                seller_company_id: avaliacao.seller_company_id,
                rate_state: 1,
                was_good: avaliacao.foi_bom,
                comments: avaliacao.avaliacao_texto
            };
        })

        this.reviewService.addManyReviews(avaliacoes).subscribe({
            next: () => {
                this.notificationService.showSuccessToastr(this.globals.translate('buyer.visao-geral.avaliacao.mensagens.sucesso.corpo'));
                this.close()
                this.ngxLoader.stopLoader('loader-avaliacao');
            },
            error: (error) => {
                console.log(error)
                this.notificationService.showErrorToastr(this.globals.translate('buyer.visao-geral.avaliacao.mensagens.erro.enviar.corpo'));
                this.ngxLoader.stopLoader('loader-avaliacao');
            }
        })
    }

    rememberInTwoHours(): void {
        this.localStorageUtilsBuyer.saveShouldOpenAvaliacoesModalData(this.userService.user())
        this.close()
    }

    selectOrder(order): void {
        this.selectedOrder = order;
    }
}
